/* global $*/
import React from "react";
import { connect } from "react-redux";

import { goTo } from "../tools";
import { servicios } from "../properties";
import { descargas, fnToSlash, fnMoneda } from "../tools";

const mapState = (state) => {
	return {
		"poliza": state.polizas.poliza,
		"recibo": state.polizas.recibo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		alertaCode: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo" : sCode });
		},
		addEvento: (evento) => {
			dispatch({ "type": "HOME_SET_EVENT", "evento": evento});
		}
	};
};

class ConfirmacionPago extends React.Component {

	getDeviceType = () => {
		
		if(typeof window.webkit != 'undefined' && window.webkit.messageHandlers) return "iOS";
		if(typeof android_conectam != 'undefined') return "android";
		return "browser";
	
	}


	close = () => {
		$("#modal-confirmar").modal("hide");
		if(this.getDeviceType()==="browser"){
			goTo("home");
		}else{
			goTo("movil/polizas");
		}		
		//window.location.href = '/#!/home';
	}
	
	print = () => {
		var queryString = "?" + $.param({
			numConfirmacion: this.props.numConfirmacion,
			numPoliza: this.props.poliza.generales.numPoliza,
			cveRamo: this.getRamo(this.props.poliza.generales.cveRamo),
			fchPeriodo: fnToSlash(this.props.recibo.fechaEfecRec) + " - " + fnToSlash(this.props.recibo.fechaVencRec),
			cveCodMoneda: this.getMoneda(this.props.recibo.cveCodMoneda),
			codNumRecibo: this.props.recibo.codNumRecibo,
			productoComercial: this.props.poliza.generales.productoComercial,
			cveFormaPago: this.getFormaPago(this.props.poliza.generales.cveFormaPago),
			impTotalRecibo: fnMoneda(this.props.recibo.impTotalRecibo)
		});
		this.props.addEvento("DescargarComprobante-Pago");
		descargas(servicios.polizas.comprobantePago + queryString, "comprobante de pago.pdf");
	}
	
	getFormaPago = (cveFormaPago) => {
		let formaPago = "Mensual";
		
		switch (cveFormaPago) {
		case "A": formaPago = "Anual"; break;
		case "M": formaPago = "Mensual"; break;
		case "T": formaPago = "Trimestrial"; break;
		case "S": formaPago = "Semestral"; break;
		case "U": formaPago = "Pago Unico"; break;
		}
		
		return formaPago;	
	}

	getRamo = (cveRamo) => {
		let ramo = "Autos";
		
		switch (cveRamo) {
		case "A": ramo = "Autos"; break;
		case "G": ramo = "Gastos Médicos Mayores"; break;
		case "V": ramo = "Vida"; break;
		case "D": ramo = "Daños"; break;
		}
		
		return ramo;
	}
	
	getMoneda = (cveCodMoneda) => {
		let moneda = "";
		
		switch (cveCodMoneda) {
		case "MXP": moneda = "Nacional"; break;
		case "USD": moneda = "Dólares"; break;
		}
		
		return moneda;
	}

	render() {
		return (
			<div className="modal fade modal-msj" id="modal-confirmar" tabIndex="-1" role="dialog" aria-labelledby="modal-confirmar">
				<div className="modal-backdrop fade in" style={{"zIndex":"0"}}></div>
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div id="confirmacioPagoHTML">
							<div className="row">
								<div className="col-xs-12">
									<i><img src={ require("../img/circle-pago-ok.svg") } alt="" className="pad-right-10" /></i>
									<span className="blue-text modal-titulo-fnt18">Pago exitoso</span>
									<span className="modal-titulo-pago">Número de Confirmación: {this.props.numConfirmacion}</span>
								</div>
							</div>
							<hr />
							<div style={{"padding":"0px 30px"}}>
								<div className="row">
									<div className="col-xs-12 col-md-6 col-lg-6">
										<ul className="list-divider">
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Número de Póliza</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name="poliza">{ this.props.poliza.generales.numPoliza }</p>
													</div>
												</div>
											</li>
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Ramo</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name="ramo">{ this.getRamo(this.props.poliza.generales.cveRamo) }</p>
													</div>
												</div>
											</li>
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Periodo que cubre el recibo</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name="periodo">{ fnToSlash(this.props.recibo.fechaEfecRec) } - { fnToSlash(this.props.recibo.fechaVencRec) }</p>
													</div>
												</div>
											</li>
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Moneda</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name="moneda">{ this.getMoneda(this.props.recibo.cveCodMoneda) }</p>
													</div>
												</div>
											</li>
											<li style={{"height":"30px"}}></li>
										</ul>
									</div>
									<div className="col-xs-12 col-md-6 col-lg-6">
										<ul className="list-divider">
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Número de recibo</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name="recibo">{ this.props.recibo.codNumRecibo }</p>
													</div>
												</div>
											</li>
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Producto</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name="producto">{ this.props.poliza.generales.productoComercial }</p>
													</div>
												</div>
											</li>
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Forma de pago</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name="pago">{ this.getFormaPago(this.props.poliza.generales.cveFormaPago) }</p>
													</div>
												</div>
											</li>
											<li className="clearfix">
												<div className="pull-left">
													<p><b>Importe del recibo</b></p>
												</div>
												<div className="pull-right">
													<div className="gray-text texto15">
														<p name="importe">$ { fnMoneda(this.props.recibo.impTotalRecibo) }</p>
													</div>
												</div>
											</li>
											<li></li>
										</ul>
									</div>
								</div>
								<div className="row">
									<div className="col-xs-12">
										<button type="submit" className="print-btn" onClick={this.print}><i><img src={require("../img/icon-print.svg")}/></i>Descargar comprobante</button>
										<button type="submit" className="orange-btn" onClick={this.close} style={{"float":"right","textAlign":"center"}}>Aceptar</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(ConfirmacionPago);


// WEBPACK FOOTER //
// ./src/home/confirmacionPago.cmpt.js